<template>
	<section class="whyjoin-block">
		<div class="row row-header">
			<div class="columns column12 align-center">
				<h2>{{ header }}</h2>
			</div>
		</div>
		<div class="row flex-row">
			<div v-for="item in items" :key="item.ID" class="columns column4 whyjoin-item">
				<picture>
					<source :srcset="item.imageWebp" type="image/webp" />
					<source :srcset="item.image" />
					<img :src="item.image" :alt="item.imageAlt" class="whyjoin-item image" loading="lazy" />
				</picture>
				<div class="content">
					<span>{{ item.header }}</span>
					<p>{{ item.content }}</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.whyjoin-block {
	background: var(--primary-background-color);
	margin: 0;
	text-align: center;

	.row-header {
		max-width: 420px;
		margin-bottom: 50px;
	}

	.whyjoin-item {
		text-align: center;
		margin: 0 auto;

		.content {
			margin: 25px auto 50px;
			max-width: 400px;
		}

		img {
			max-width: 180px;
			margin: 0 0 10px;
		}

		span {
			display: inline-block;
			width: 100%;
			text-align: center;
			font-size: 21px;
			text-transform: uppercase;
		}
	}
}

@media (max-width: 1080px) {
	.whyjoin-item {
		img {
			max-width: 200px;
		}

		span {
			font-size: 18px;
		}
	}
}

@media (max-width: 580px) {
	.whyjoin-item {
		span {
			font-size: 16px;
		}
	}
}
</style>
